import React, { useEffect, useState} from 'react';
import {Container, Row, Col, Button} from 'react-bootstrap';
import './Signup.css';
import Topbar from "../../Topbar"; 
import Footer from "../../Footer";
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import API from '../../../Utils/Api';
import {validate} from '../../../Utils/validate';
import loader from '../../../assests/loader.gif';
import { setUserSession } from '../../../Utils/Common';
import { gettoastwarning } from '../../../Utils/Common';

import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import Modal from 'react-bootstrap/Modal';


const Signup = () => {
const [loading,setLoading] = useState(false);

const [inputslogin,setInputslogin] = useState({});
const [inputs,setInputs] = useState({first_name:'',last_name:'',email:'',contact_number:'',password:'',confirm_password:'',pincode:'',state:'',city:'',town:''});

const [errors,setErrors] = useState({});

const [state, setState] = useState([]);
const [city, setCity] = useState([]);
const [town, setTown] = useState([]);

const [show, setShow] = useState(false);

const GoogleSignInButton = () => {
  
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      const accessToken = tokenResponse.access_token;
      fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(response => response.json())
      .then(profile => {
        //console.log("Google profile:", profile);
        var email=profile.email;
        var provider_id=profile.sub;
       
        var name = profile.name; 
				var firstName = profile.given_name; 
				var lastName = profile.family_name;

        // Example usage:
        let formData = new FormData();
        formData.append('email', email);
        formData.append('type', 1);
        formData.append('login_type', 'gmail');
        formData.append('social_token', provider_id);
        formData.append('name', name);
				formData.append('first_name', firstName);
				formData.append('last_name', lastName);
        API.post('login_with_social', formData)
          .then(response => {
            if (response.data.status === false) {
              gettoastwarning(response.data.message, '');
              setLoading(false);
            } else {
              setLoading(false);
              if(response.data.data.role===1)
	         		{
	         				const expiryTime = Date.now() + 3600000;  
      						localStorage.setItem("session_expiry", expiryTime);
		              setUserSession(response.data.data.token,response.data.data.role);
		              localStorage.setItem("location_id", response.data.data.location_id);
			         		localStorage.setItem("location_town", response.data.data.location_town_name);
			        
				          var loc='';
				        	if(response.data.data.location_pincode!=='' && response.data.data.location_town_name!=='')
				        	{
				          	loc = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
				          }
				         localStorage.setItem("location", loc);
		              var is_profile_verify=response.data.data.is_profile_verify;
									localStorage.setItem("is_profile_verify", is_profile_verify);
									if(is_profile_verify===1){
										window.location.href = '/neighbour/local-deals';
									}else{
										window.location.href = '/neighbour/complete-profile';
									}
		             }else if(response.data.data.role===2){
		             		if(response.data.data.is_popup_open===0)
					 					{
									 		setInputslogin(response.data.data);
									 		setShow(true);
									 	}else{
									 		const expiryTime = Date.now() + 3600000;  
      								localStorage.setItem("session_expiry", expiryTime);
      								localStorage.setItem("business_id", response.data.data.business_id);
									 		setUserSession(response.data.data.token,response.data.data.role);
							         localStorage.setItem("location_id", response.data.data.location_id);
							         localStorage.setItem("location_town", response.data.data.location_town_name);
							        	var loc1='';
							        	if(response.data.data.location_pincode!=='' && response.data.data.location_town_name!=='')
							        	{
							          	loc1 = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
							          }
							         localStorage.setItem("location", loc1);
											 var is_profile_verify3=response.data.data.is_profile_verify;
											localStorage.setItem("is_profile_verify", is_profile_verify3);
											if(is_profile_verify3===1){
												window.location.href = '/neighbour/local-deals';
											}else{
												window.location.href = '/neighbour/complete-profile';
											}
									 	}
								 }
            }
          })
          .catch(error => {
            setLoading(false);
            gettoastwarning('Something went wrong. Please try again later.', '');
          });

      })
      .catch(error => {
        console.error("Error fetching Google profile:", error);
        setLoading(false);
        gettoastwarning('Failed to fetch user profile from Google.', '');
      }); 
    },
    onError: () => {
      console.log('Login Failed');
    },
  });

  return (
  	<Link to="" className='go-btn' onClick={() => login()}><div><h6>Continue with Google</h6> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/googlewh.webp'} className="img-fluid" alt="googlewh"/></div></Link>
  );
};


useEffect(() => {
	  document.title = `Signup | Local Bells`;
	  document.getElementById('bodywrap').className='nesignup';

	  API.post('get_state')
	      .then(response => {
	      setState(response.data.data);       
	  });
},[]);

  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => {
		setShowPassword(prevState => !prevState);
  };

  const [showConfPassword, setShowConfPassword] = useState(false);

  const toggleConfPassword = () => {
		setShowConfPassword(prevState => !prevState);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(inputs);
     const noErrors = Object.keys(validationErrors).length === 0;
		setErrors({});
        setErrors(validationErrors);
		
		if(noErrors){
				setLoading(true);
			
		    let formData = new FormData(); 
		    Object.keys(inputs).forEach((key) => {
            formData.append(key, inputs[key]);
        });
		    API.post('register', formData)
		      .then(response => {
		      if(response.data.status === false){
		        //setError(response.data.message);
		        setLoading(false); 
		        gettoastwarning(response.data.message,'');
		      }else{
		         
		         setLoading(false);
		         const expiryTime = Date.now() + 3600000;  
      			localStorage.setItem("session_expiry", expiryTime);
		         setUserSession(response.data.data.token,response.data.data.role);
              localStorage.setItem("location_id", response.data.data.location_id);
	         		localStorage.setItem("location_town", response.data.data.location_town_name);
	        
		          var loc='';
		        	if(response.data.data.location_pincode!=='' && response.data.data.location_town_name!=='')
		        	{
		          	loc = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
		          }
		         localStorage.setItem("location", loc);
              var is_profile_verify1=1;
								localStorage.setItem("is_profile_verify", is_profile_verify1);
								
									window.location.href = '/neighbour/local-deals';
								
		         //gettoastsuccess(response.data.message,'/');
		      }                  
		    }).catch(error => {
		       setLoading(false);
		       gettoastwarning("Something went wrong. Please try again later.",'');
		        //setError("Something went wrong. Please try again later.");
		    });
		}
    //navigate('/neighbour/login');
  };
/* Start Value set */
const handleInputChange = (event) => {
  event.persist();
  setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
}
const handleInputChangeEmail = (event) => {
  event.persist();
  const { name, value } = event.target;

  // Regex for allowed email characters
  const regex = /^[a-zA-Z0-9@._-]*$/;

  if (regex.test(value)) {
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }        
}
const handleInputChangeMo = (event) => {
  event.persist();
  const { name, value } = event.target;

  // Allow only numbers (0–9)
  const regex = /^[0-9]*$/;

  if (regex.test(value)) {
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }      
}
const handleInputChangeSpe = (event) => {
  event.persist();
  const { name, value } = event.target;

  // Allow only letters, numbers, spaces, and basic punctuation if needed
  const regex = /^[a-zA-Z0-9\s]*$/;

  if (regex.test(value)) {
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }    
}
/* End Value set */

const getCity = (event) => {     
      event.preventDefault();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value})); 
      setTown([]);  
      var st='city';
      var st_val='';
       setInputs(inputs => ({...inputs, [st]: st_val})); 

       var ct='town';
      var ct_val='';
       setInputs(inputs => ({...inputs, [ct]: ct_val})); 

      let formData = new FormData(); 
          formData.append('state_id', event.target.value);
          API.post('get_city', formData)
                    .then(response => {
                      
                    if(response.data.status === true){
                     setCity(response.data.data);  
                    }else{
                        
                    }
                  }).catch(error => {
                      
              }); 
  }

const getTown = (event) => {     
      event.preventDefault();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value})); 
      setTown([]);  
       var ct='town';
      var ct_val='';
       setInputs(inputs => ({...inputs, [ct]: ct_val})); 

      let formData = new FormData(); 
          formData.append('city_id', event.target.value);
          API.post('get_town', formData)
                    .then(response => {
                      
                    if(response.data.status === true){
                     setTown(response.data.data); 

                     var ct1 = 'town';
						          var ct_val1 = response.data.extra_data.town_id;
						          setInputs(inputs => ({ ...inputs, [ct1]: ct_val1 }));

						          var pin1 = 'pincode';
						          var pin_val1 = response.data.extra_data.pincode;
						          setInputs(inputs => ({ ...inputs, [pin1]: pin_val1 }));

                    }else{
                          
                    }
                  }).catch(error => {    
          }); 
}
const responseFacebook = (response) => {
	console.log(response);
	if(!response.accessToken)
	{
		setLoading(false);
		gettoastwarning("Facebook login failed, please try again.", "/neighbour/login");
	}else{
		var email='';
		if(response.email)
		{
			email=response.email;
		}
		var name = response.name || '';     
			var firstName = response.first_name || ''; 
			var lastName = response.last_name || '';
	var id=response.id;
		setLoading(true);
			let formData = new FormData(); 
			formData.append('email', email);
        formData.append('type', 1);
        formData.append('login_type', 'facebook');
        formData.append('social_token', id);
       formData.append('name', name);
			formData.append('first_name', firstName);
			formData.append('last_name', lastName);
			API.post('login_with_social', formData)
				.then(response => {
					
				if (response.data.status === false) {
              gettoastwarning(response.data.message, '');
              setLoading(false);
            } else {
              setLoading(false);
              if(response.data.data.role===1)
	         		{
	         			const expiryTime = Date.now() + 3600000;  
      					localStorage.setItem("session_expiry", expiryTime);
      					localStorage.setItem("business_id", response.data.data.business_id);
	              setUserSession(response.data.data.token,response.data.data.role);
	              localStorage.setItem("location_id", response.data.data.location_id);
				         localStorage.setItem("location_town", response.data.data.location_town_name);
				          var loc='';
				        	if(response.data.data.location_pincode!=='' && response.data.data.location_town_name!=='')
				        	{
				          	loc = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
				          }
				         localStorage.setItem("location", loc);
			              var is_profile_verify=response.data.data.is_profile_verify;
									localStorage.setItem("is_profile_verify", is_profile_verify);
									if(is_profile_verify===1){
										window.location.href = '/neighbour/local-deals';
									}else{
										window.location.href = '/neighbour/complete-profile';
									}
			          }else if(response.data.data.role===2){
			          	if(response.data.data.is_popup_open===0)
					 				{
								 		setInputslogin(response.data.data);
								 		setShow(true);
								 	}else{
								 		const expiryTime = Date.now() + 3600000;  
      							localStorage.setItem("session_expiry", expiryTime);
								 		setUserSession(response.data.data.token,response.data.data.role);
						         localStorage.setItem("location_id", response.data.data.location_id);
						         localStorage.setItem("location_town", response.data.data.location_town_name);
						        	var loc1='';
						        	if(response.data.data.location_pincode!=='' && response.data.data.location_town_name!=='')
						        	{
						          	loc1 = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
						          }
						         localStorage.setItem("location", loc1);							   
										 var is_profile_verify2=response.data.data.is_profile_verify;
											localStorage.setItem("is_profile_verify", is_profile_verify2);
											if(is_profile_verify2===1){
												window.location.href = '/neighbour/local-deals';
											}else{
												window.location.href = '/neighbour/complete-profile';
											}
								 	}
							 }
            }                  
			}).catch(error => {
				setLoading(false);
        gettoastwarning('Failed to fetch user profile from Google.', '');
			});  
	}
}
const getCat = (event) => {     
      event.preventDefault();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value})); 
      get_town_picode(event.target.value);
}
const get_town_picode = (id) => {
        let formData = new FormData(); 
         formData.append('town_id', id);
        API.post('get_town_pincode',formData)
            .then(response => {
              
            if(response.data.status === true){
                if(response.data.data.city_id!=='')
                {
                    var pincode_label='pincode';
                    var pincode_val=response.data.data.pincode;
                    setInputs(inputs => ({...inputs, [pincode_label]: pincode_val}));
                }
            }else{
                    
            }
          }).catch(error => {
              
      });
}

const getpicode_town = () => {
    if(inputs.pincode!=='')
    {
          let formData = new FormData(); 
           formData.append('pin_code', inputs.pincode);
          API.post('get_pincode_town',formData)
              .then(response => {
                
              if(response.data.status === true){
                  if(response.data.data.city_id!=='' && response.data.data.city_id!=='')
                  {
                      setCity(response.data.data.city);
                      setTown(response.data.data.town);
                      var state_label='state';
                      var state=response.data.data.state_id;
                      setInputs(inputs => ({...inputs, [state_label]: state}));

                      var city_label='city';
                      var city=response.data.data.city_id;
                      setInputs(inputs => ({...inputs, [city_label]: city}));

                      var town_label='town';
                        var town=response.data.data.town_id;
                        setInputs(inputs => ({...inputs, [town_label]: town}));

                        var town_text=response.data.data.town_name;
                            var town_name_lbl="town_name";
                            setInputs(inputs => ({ ...inputs, [town_name_lbl]: town_text }));
                  }else{
									setCity([]);
							        setTown([]);
							        var state_label3 = 'state';
							        var state3 = '';
							        setInputs(inputs => ({ ...inputs, [state_label3]: state3 }));

							        var city_label3 = 'city';
							        var city3 = '';
							        setInputs(inputs => ({ ...inputs, [city_label3]: city3 }));

							        var town_label3 = 'town';
							        var town3 = '';
							        setInputs(inputs => ({ ...inputs, [town_label3]: town3 }));

							        var town_text3='';
							            var town_name_lbl3="town_name";
							            setInputs(inputs => ({ ...inputs, [town_name_lbl3]: town_text3 }));
								}
              }else{
                    setCity([]);
						        setTown([]);
						        var state_label1 = 'state';
						        var state1 = '';
						        setInputs(inputs => ({ ...inputs, [state_label1]: state1 }));

						        var city_label1 = 'city';
						        var city1 = '';
						        setInputs(inputs => ({ ...inputs, [city_label1]: city1 }));

						        var town_label1 = 'town';
						        var town1 = '';
						        setInputs(inputs => ({ ...inputs, [town_label1]: town1 }));

						        var town_text1='';
						            var town_name_lbl1="town_name";
						            setInputs(inputs => ({ ...inputs, [town_name_lbl1]: town_text1 }));  
              }
            }).catch(error => {    
        });
    }else{
    	setCity([]);
        setTown([]);
        var state_label2 = 'state';
        var state2 = '';
        setInputs(inputs => ({ ...inputs, [state_label2]: state2 }));

        var city_label2 = 'city';
        var city2 = '';
        setInputs(inputs => ({ ...inputs, [city_label2]: city2 }));

        var town_label2 = 'town';
        var town2 = '';
        setInputs(inputs => ({ ...inputs, [town_label2]: town2 }));

        var town_text2='';
        var town_name_lbl2="town_name";
        setInputs(inputs => ({ ...inputs, [town_name_lbl2]: town_text2 }));
    }
}
const handleClose = () => setShow(false);
const handleYes = () => {
					const expiryTime = Date.now() + 3600000;  
      		localStorage.setItem("session_expiry", expiryTime);
					localStorage.setItem("business_id", inputslogin.business_id);
	         setUserSession(inputslogin.token,inputslogin.role);
	         localStorage.setItem("location_id", inputslogin.location_id);
	         localStorage.setItem("location_town", inputslogin.location_town_name);
	        
	          var loc='';
	        	if(inputslogin.location_pincode!=='' && inputslogin.location_town_name!=='')
	        	{
	          	loc = `${inputslogin.location_town_name} - ${inputslogin.location_pincode}`;
	          }
	         localStorage.setItem("location", loc);
	         if(inputslogin.switch_business_to_customer===1)
					 	{
					 		var is_profile_verify=inputslogin.is_profile_verify;
							localStorage.setItem("is_profile_verify", is_profile_verify);
							if(is_profile_verify===1){
								window.location.href = '/neighbour/local-deals';
							}else{
								window.location.href = '/neighbour/complete-profile';
							}
					 	}else{
    					window.location.href='/business/switch-neighbour-profile';
					 	}
};

    return (
        <>
          <Topbar />
		  	<Container className="px-0">
				<section className='signup-main'>
						<Row className='justify-content-center'>
							<Col md={8} lg={5} xs={12}>
								<div className="signup-form-box">
									<div className='sfb-title'>
										<h2><span>Sign Up</span></h2>
										<h5>Create an Account with LocalBells</h5>
									</div>
									<Form onSubmit={handleSubmit}>
										<Row>
											<Col className='pe-2'>
												<Form.Control className="mb-2" type="text" placeholder="First name" name="first_name" onChange={handleInputChangeSpe} value={inputs.first_name} />
												{errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
											</Col>
											<Col className='ps-2'>
												<Form.Control className="mb-2" type="text" placeholder="Last name" name="last_name" onChange={handleInputChangeSpe} value={inputs.last_name} />
												{errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
											</Col>
										</Row>	
											<Form.Group className="col mb-3">														
												<Form.Control className="mb-2 mt-2 form-control" type="email" placeholder="Email Address" name="email" onChange={handleInputChangeEmail} value={inputs.email} />
												{errors.email && (<p className="text-danger">{errors.email}</p>)}
										</Form.Group>
										<Form.Group className="col mb-3">							
											<Form.Control className="mb-2" type="text" placeholder="Contact number" name="contact_number" onChange={handleInputChangeMo} value={inputs.contact_number} maxLength={15}  />	
											{errors.contact_number && (<p className="text-danger">{errors.contact_number}</p>)}
										</Form.Group>										
										<InputGroup className="mb-2">
											<Form.Control
											placeholder="Create Password"
											aria-label="password"
											aria-describedby="basic-addon1"
											type={showPassword ? 'text' : 'password'}
											name="password" onChange={handleInputChange} value={inputs.password}
											/>
											
											<InputGroup.Text id="basic-addon1" onClick={togglePassword}>
												{/*<Image src={showPassword ? '../assets/images/show.webp' : '../assets/images/hide.webp'} className="img-fluid" alt={showPassword ? 'hide' : 'show'} />*/}
											<Image
										src={
											showPassword
											? process.env.REACT_APP_BASE_URL + 'assets/images/show.webp'
											: process.env.REACT_APP_BASE_URL + 'assets/images/hide.webp'
										}
										className="img-fluid"
										alt={showPassword ? 'hide' : 'show'}
										/>
											</InputGroup.Text>
										</InputGroup>
										{errors.password && (<p className="text-danger">{errors.password}</p>)}
										<InputGroup className="mb-2">
											<Form.Control
											placeholder="Confirm Password"
											aria-label="password"
											aria-describedby="basic-addon1"
											type={showConfPassword ? 'text' : 'password'}
											name="confirm_password" onChange={handleInputChange} value={inputs.confirm_password}
											/>
											<InputGroup.Text id="confpassword" onClick={toggleConfPassword}>
												{/*<Image src={showConfPassword ? '../assets/images/show.webp' : '../assets/images/hide.webp'} className="img-fluid" alt={showConfPassword ? 'hide' : 'show'} />*/}
												<Image
											src={
												showConfPassword
												? process.env.REACT_APP_BASE_URL + 'assets/images/show.webp'
												: process.env.REACT_APP_BASE_URL + 'assets/images/hide.webp'
											}
											className="img-fluid"
											alt={showConfPassword ? 'hide' : 'show'}
											/>
											</InputGroup.Text>
										</InputGroup>		
										{errors.confirm_password && (<p className="text-danger">{errors.confirm_password}</p>)}
										<Form.Group className="col mb-3">
											<Form.Control className="mb-2" type="text" placeholder="Pin Code" name="pincode" onChange={handleInputChangeMo} onBlur={getpicode_town} value={inputs.pincode} maxLength={6} />
											{errors.pincode && (<p className="text-danger">{errors.pincode}</p>)}	
										</Form.Group>																							
										<Row>
											<Col>
												<Form.Select className="mb-2" aria-label="Default select example" name="state" onChange={getCity} value={inputs.state}>
													<option value="">State</option>
												{state && state.map((val, index) => {
							return (
																	<option value={val.id}>{val.name}</option>
																)
							})}	
												</Form.Select>		
												{errors.state && (<p className="text-danger">{errors.state}</p>)}									
											</Col>
											<Col>
												<Form.Select className="mb-2" aria-label="Default select example" name="city" onChange={getTown} value={inputs.city}>
													<option value="">City</option>
													{city && city.map((val, index) => {
							return (
																<option value={val.id}>{val.name}</option>
															)
							})}
												</Form.Select>	
												{errors.city && (<p className="text-danger">{errors.city}</p>)}														
											</Col>
											<Col>
												<Form.Select className="mb-2" aria-label="Default select example" name="town" onChange={getCat} value={inputs.town}>
													<option value="">Locality</option>
												{town && town.map((val, index) => {
							return (	
															<option value={val.id}>{val.name}</option>
														)
													})}										
												</Form.Select>		
												{errors.town && (<p className="text-danger">{errors.town}</p>)}										
											</Col>
										</Row>
										<Button variant="primary" type="submit" className='blue-btn'>
											<h6>Signup</h6>
										</Button>
									</Form>
									<div className='or-box'>
										<span>or</span>
									</div>
									<GoogleOAuthProvider clientId={process.env.REACT_APP_GMAIL_CLIENT_ID}>
					<GoogleSignInButton />
					</GoogleOAuthProvider>
									{/*<Link to="/" className='go-btn'><div><h6>Continue with Google</h6> <Image src="../assets/images/googlewh.webp" className="img-fluid" alt="googlewh"/></div></Link>*/}
									{/*<Link to="/" className='fb-btn'><div><h6>Continue with Facebook</h6> <Image src="../assets/images/fbwh.webp" className="img-fluid" alt="fbwh"/></div></Link>*/}
									<FacebookLogin
							appId={process.env.REACT_APP_FACEBOOK_APP_ID}
							autoLoad={false}
							fields="name,email,picture"
							callback={responseFacebook}
							render={(renderProps) => (
								<Link
								to="#"
								onClick={renderProps.onClick}
								className="fb-btn"
								>
								<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
									<h6 style={{ margin: 0 }}>Continue with Facebook</h6>
									<Image
									src={process.env.REACT_APP_BASE_URL + 'assets/images/fbwh.webp'}
									className="img-fluid"
									alt="fbwh"
									style={{ width: "24px", height: "24px" }}
									/>
								</div>
								</Link>
							)}
							/>
									<p>By signing up, you agree to our <Link to="/neighbour/privacy">Privacy Policy</Link>,<Link to="/">Cookie Policy</Link>, and <Link to="/neighbour/terms">Member Agreement</Link>.</p>
									<p>Sign up as a business? <Link to="/business/register">Click Here</Link></p>
								</div>						
							</Col>
						</Row>        			
				</section>
			</Container>
			<Footer />
			<Modal
                show={show}
                size="md"
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Login</Modal.Title>
                </Modal.Header>
                <Modal.Body className='review-modal'>
                    <Row>
            <Col md={12} className="text-center">
                {/* Message */}
                <p style={{ lineHeight: "1.6", fontSize: "16px" }}>
                   This email 
is already associated 
with a Business user. 
Would you like to 
link a Neighbor 
profile as well?
                </p>

                {/* Buttons */}
                <div className="mt-4 d-flex justify-content-center gap-3">
                    <button className="btn btn-primary" onClick={handleYes}>
                        Yes
                    </button>

                    <button className="btn btn-secondary" onClick={handleClose}>
                        No
                    </button>
                </div>

            </Col>
        </Row>
                </Modal.Body>
            </Modal>
			{loading && (
       <div className="loadingClass">
        <img src={loader} alt="loader"/>
      </div>
       )}  
        </>
    )
}
export default Signup;


